import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicUsertaskUpdateParamsRawI,
	LWApiPublicUsertaskUpdateResultRawI,
} from '@liquidweb-dev/club-sauce/public/usertask/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { USERTASK_LIST_QUERY_KEY } from './useList';
import { ASSET_DETAILS_QUERY_KEY } from '../asset/useDetails';
import { ASSET_LIST_QUERY_KEY } from '../asset/useList';

export const USERTASK_UPDATE_QUERY_KEY = '/usertask/update';

const useUsertaskUpdate = (opts?: { showSnackbarOnError?: boolean }) => {
	const { showSnackbarOnError = true } = opts || {};
	const snackbarError = useSnackbarError();
	const queryClient = useQueryClient();
	return useMutation<
		LWApiPublicUsertaskUpdateResultRawI,
		ApiErrorI,
		LWApiPublicUsertaskUpdateParamsRawI
	>({
		mutationKey: [USERTASK_UPDATE_QUERY_KEY],
		mutationFn: (params) => api.usertask.apiRaw.update(params),

		onSuccess: (params) => {
			queryClient.invalidateQueries([USERTASK_LIST_QUERY_KEY]);
			queryClient.invalidateQueries({
				queryKey: [ASSET_DETAILS_QUERY_KEY, { uniq_id: params.uniq_id }],
			});
			queryClient.invalidateQueries({ queryKey: [ASSET_LIST_QUERY_KEY] });
		},

		onError: showSnackbarOnError ? snackbarError : undefined,
	});
};

export default useUsertaskUpdate;
